document.addEventListener('keydown', event => {if(event.key === 'Escape'){document.querySelectorAll('.mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});}});
document.querySelectorAll('#SubscriptionInterest').forEach(form => {
  const size = form.querySelector('#SubSize');
  const money = cents => new Intl.NumberFormat('en-IE', {style:'currency',currency:'EUR'}).format(cents / 100);
  const update = () => {
    const regular = Math.round(Number(size.selectedOptions[0].dataset.price) * 100);
    const discounted = Math.round(regular * 95 / 100);
    form.querySelector('#SubPrice').textContent = money(discounted) + ' per bag';
    form.querySelector('#SubRegular').textContent = money(regular);
    form.querySelector('#SubSaving').textContent = ' · Save ' + money(regular - discounted) + ' per bag';
  };
  size.addEventListener('change', update); size.addEventListener('input', update); update();
});

document.querySelectorAll('.purchase-options').forEach(panel => {
  const form = panel.closest('form');
  const variant = form.querySelector('#CoffeeVariant');
  const plan = panel.querySelector('[name="selling_plan"]');
  const update = () => {
    const previous = plan.value;
    const template = Array.from(panel.querySelectorAll('template')).find(t => t.dataset.purchaseVariant === variant.value);
    if (!template) { plan.disabled = true; return; }
    plan.replaceChildren(template.content.cloneNode(true));
    plan.disabled = false;
    if (Array.from(plan.options).some(option => option.value === previous)) plan.value = previous;
  };
  variant.addEventListener('change', update);
  variant.addEventListener('input', update);
});

// Keep the roastery film quiet; fall back to its still image when motion is unavailable.
document.querySelectorAll('.roastery-film video').forEach(video => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let visible = false;
  const still = () => {
    video.pause();
    const image = document.createElement('img');
    image.src = video.poster;
    image.alt = video.getAttribute('aria-label');
    image.width = 720; image.height = 1280;
    video.replaceWith(image);
  };
  if (motion.matches) { still(); return; }
  video.muted = true;
  video.addEventListener('error', still, {once: true});
  const observer = new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;
    if (visible) video.play().catch(still);
    else video.pause();
  }, {threshold: 0.15});
  observer.observe(video);
  motion.addEventListener('change', event => {
    if (event.matches) { observer.disconnect(); still(); }
  });
});

// Separate weight and grind controls retain the exact Shopify variant for checkout.
document.querySelectorAll('[data-coffee-modifiers]').forEach(panel => {
 const form = panel.closest('form'), select = form.querySelector('#CoffeeVariant');
 const variants = Array.from(select.options).map(option => ({option, parts: option.dataset.title.split(' / ')}));
 if (!variants.every(v => v.parts.length === 2)) return;
 const icons = {
 Wholebean: '<ellipse cx="19" cy="29" rx="8" ry="12" transform="rotate(-35 19 29)"/><path d="M14 20c10 5 0 12 10 18"/><ellipse cx="42" cy="20" rx="8" ry="12" transform="rotate(30 42 20)"/><path d="M46 10c-10 6 0 12-9 19"/>',
 Espresso: '<rect x="9" y="9" width="46" height="25" rx="3"/><path d="M14 34v18h36V34M9 55h46M27 26h12M33 26v12M24 39h17v7a5 5 0 0 1-5 5h-7a5 5 0 0 1-5-5z"/><circle cx="20" cy="20" r="3"/>',
 Aeropress: '<path d="M21 8h22M24 8v9M40 8v9M19 17h26M22 17v31h20V17M19 48h26v6H19zM26 54v5h12v-5"/><circle cx="32" cy="26" r="1"/><circle cx="32" cy="34" r="1"/><circle cx="32" cy="42" r="1"/>',
 Filter: '<path d="M13 10h38L38 34H26zM22 13l8 18M32 13v18M42 13l-8 18M19 35h26M26 36v6l-8 13h28l-8-13v-6M22 49h20"/>'
 };
 const selected = variants.find(v => v.option.selected) || variants[0];
 const values = [...selected.parts];
 const groups = ['weight', 'grind'].map((name, index) => {
   const field = document.createElement('fieldset'); field.className = 'coffee-modifier';
   const legend = document.createElement('legend');
   const strong = document.createElement('strong'); strong.textContent = 'Choose ' + name + ': ';
   const current = document.createElement('span'); current.textContent = values[index];
   legend.append(strong, current); field.append(legend);
   const choices = document.createElement('div'); choices.className = 'modifier-choices'; field.append(choices);
   [...new Set(variants.map(v => v.parts[index]))].forEach(value => {
     const label = document.createElement('label'); label.className = 'modifier-choice';
     const input = document.createElement('input'); input.type = 'radio'; input.name = 'brevet-' + name; input.value = value; input.checked = value === values[index];
     const face = document.createElement('span'); face.className = 'modifier-face';
     if (index === 1 && icons[value]) face.innerHTML = '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + icons[value] + '</svg>';
     const text = document.createElement('span'); text.textContent = value; face.append(text);
     label.append(input, face); choices.append(label);
     input.addEventListener('change', () => {values[index] = value; update();});
   });
   panel.append(field); return {field,current};
 });
 function update() {
   const match = variants.find(v => v.parts.every((part,i) => part === values[i]));
   groups.forEach((g,i) => {g.current.textContent = values[i];g.field.querySelectorAll('input').forEach(input => {
     input.disabled = !variants.some(v => !v.option.disabled && v.parts[i] === input.value && v.parts[1-i] === values[1-i]);
   });});
   if (!match) return;
   select.value = match.option.value;
   const price = form.closest('.product-copy').querySelector('[data-coffee-price]');
   price.textContent = match.option.dataset.price;
   const submit = form.querySelector('button[type="submit"]'); submit.disabled = match.option.disabled; submit.textContent = match.option.disabled ? 'Sold out' : 'Add to bag';
   select.dispatchEvent(new Event('change', {bubbles:true}));
 }
 select.hidden = true; form.querySelector('[data-variant-label]').hidden = true;
 update();
});
